import {Component, OnInit} from '@angular/core';
import {UserService} from '../../Services/User/user.service';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {map} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {IAppState} from '../../store/state/app.state';
import {LoginCompanyEmployeeSuccess} from '../../store/actions/companyEmployee.action';

@Component({
  selector: 'app-super-admin-dashboard',
  templateUrl: './super-admin-dashboard.component.html',
  styleUrls: ['./super-admin-dashboard.component.scss']
})
export class SuperAdminDAshboardComponent implements OnInit {

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map((result: any) => result.matches)
    );
  name: string;
  company_name: string;
  show = false;

  constructor(private userService: UserService,
              private router: Router,
              private breakpointObserver: BreakpointObserver,
              private store: Store<IAppState>) {
  }

  ngOnInit() {
    // console.log(this.userService.getUserdetails())
    this.name = this.userService.getUserdetails().name;
    this.company_name = this.userService.getUserdetails()?.CompanyUser?.company_id.company_name;
  }

  logout() {

    const confirmAction = confirm(`Are you sure to Logout?`);
    if (confirmAction) {
      this.router.navigate(['login'], {replaceUrl: true});
      this.userService.destroyUserdetails();
      this.store.dispatch(new LoginCompanyEmployeeSuccess(null));
    }
  }
}
